export default "__VITE_ASSET__HJUIKn8E__"